import { useState, useEffect } from 'react'
import API from '../../../../../../utils/api'
import { useToken } from '../../../../../hooks'

const userCache = new Map()

export function useUserInfo(userId: number | string) {
	const [userInfo, setUserInfo] = useState<any>(null)
	const [loading, setLoading] = useState(false)
	const { data: token } = useToken()

	useEffect(() => {
		if (!userId || !token) {
			setUserInfo(null)
			return
		}

		// 캐시에서 먼저 확인
		const cacheKey = `user_${userId}`
		if (userCache.has(cacheKey)) {
			setUserInfo(userCache.get(cacheKey))
			return
		}

		setLoading(true)
		
		API.get(
			`/group/users/${userId}?user_id=${userId}`,
			token + '',
			{},
			false
		).then((res: any) => {
			if (res?.result?.success) {
				const userData = res?.result?.result
				userCache.set(cacheKey, userData)
				setUserInfo(userData)
			} else {
				setUserInfo(null)
			}
		}).catch(() => {
			setUserInfo(null)
		}).finally(() => {
			setLoading(false)
		})
	}, [userId, token])

	return { userInfo, loading }
}
